import { useCallback, useState } from "react";
import { useApiCall } from "../apiHelpers";
import { GetAllTimeslotsResponse, SearchFieldType } from "../../../pages/Marketing/Timeslots/types";

interface GetAllTimeslotsParams {
    page?: number;
    itemsPerPage?: number;
    search?: string;
    searchField?: SearchFieldType;
}

const useGetAllTimeslots = () => {
    const { authFetch, isReady, run, isLoading, error } = useApiCall();
    const [data, setData] = useState<GetAllTimeslotsResponse | null>(null);

    const getAllTimeslots = useCallback(async (params: GetAllTimeslotsParams = {}): Promise<GetAllTimeslotsResponse | null> => {
        const { page = 1, itemsPerPage = 10, search, searchField = "entity_name" } = params;
        const queryParams = new URLSearchParams({ page: page.toString(), itemsPerPage: itemsPerPage.toString() });
        const trimmedSearch = search?.trim();
        if (trimmedSearch) queryParams.set(searchField, trimmedSearch);
        const outcome = await run<GetAllTimeslotsResponse>(
            () => authFetch(`/getAllTimeslots?${queryParams.toString()}`, { method: "GET" }),
            "An unknown error occurred",
        );
        if (!outcome.ok) return null;
        setData(outcome.data);
        return outcome.data;
    }, [authFetch, run]);

    return { getAllTimeslots, loading: isLoading, error, data, isReady };
};

export default useGetAllTimeslots;
